import { ref, watch } from '@vue/composition-api'
import { dateFormat } from '@/utils/date-format'

export default function useRewardsList(ctx, role) {
  const tableColumns = [
    { key: 'name', formatter: val => val.en },
    { label: 'Effective Date', key: 'effectiveTime', formatter: val => dateFormat(val) },
    { label: 'Expiry Date', key: 'endTime', formatter: val => dateFormat(val) },
    { key: 'group' },
    { key: 'Role', formatter: (_, _1, val) => val.criteria.role },
    'actions',
  ]
  const rewardsList = ref([])
  const totalRewards = ref(0)
  const fetching = ref(false)
  const queryParams = ref({
    page: 1,
    perPage: 10,
  })

  const getRewards = async () => {
    fetching.value = true
    rewardsList.value = []
    const result = await ctx.root.$store.dispatch('rewards/fetchRewards', {
      ...queryParams.value,
      role,
    })
    rewardsList.value = result.rewards
    totalRewards.value = result.total
    fetching.value = false
  }
  const toBeDeletedReward = ref(null)
  const deletePopupHandler = event => {
    toBeDeletedReward.value = { ...event }
    ctx.root.$bvModal.show('delete-reward-modal')
  }
  watch(() => queryParams.value.perPage, () => getRewards())

  getRewards()
  return {
    tableColumns,
    toBeDeletedReward,
    fetching,
    queryParams,
    deletePopupHandler,
    rewardsList,
    getRewards,
    totalRewards,
  }
}
